// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 导入字体 - 使用系统字体栈，优先使用 Inter */

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Microsoft JhengHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);
  min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #94a3b8, #64748b);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #64748b, #475569);
}

/* 滚动条平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 选中文字样式 */
::selection {
  background: rgba(255, 111, 32, 0.2);
  color: var(--primary);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAG9B;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2JAA2J;EAC3J,mCAAmC;EACnC,kCAAkC;EAClC,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA;EACE,+EAA+E;AACjF;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,YAAY;AACZ;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,qBAAqB;AACvB","sourcesContent":["/* 导入字体 - 使用系统字体栈，优先使用 Inter */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Microsoft JhengHei', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);\n  min-height: 100vh;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* 自定义滚动条样式 */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #94a3b8, #64748b);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #64748b, #475569);\n}\n\n/* 滚动条平滑滚动 */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* 选中文字样式 */\n::selection {\n  background: rgba(255, 111, 32, 0.2);\n  color: var(--primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
